export const iconFontAwesomeTravelHotelTruckMonster = (
	<i className="fa-solid fa-truck-monster"></i>
);
